import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { TripsPage } from "@/features/trips/pages/trips-page/trips-page";
import { tripsFiltersSchema } from "@/features/trips/schemas/trips-filters.schema";

export const Route = createFileRoute("/_authenticated/fleet/trips")({
	head: () => pageTitle("Trips"),
	component: TripsPage,
	validateSearch: zodValidator(tripsFiltersSchema),
});
